<!-- 
this component should be ONLY be used to toggle hidden questions
when an option is selected an action is dispatched with the question instance as the payload
 -->
<template>
  <div :class="[question.Source?.toLowerCase()]">
    <div class="col-12 col-md-6 pa-0" :class="[question.StyleClass]">
      <HomeBaseLabel
        :question="question"
        :class="[question?.LabelStyleClass]"
      />
      <v-select
        dense
        outlined
        :hide-details="
          question.HideDetails != null ? question.HideDetails : 'auto'
        "
        :data-uiid="question.DataUiid"
        :items="question.Options"
        placeholder="Please select..."
        item-text="Text"
        item-value="Value"
        v-model="question.Value"
        @change="getValue(question, true)"
        :rules="getRules"
        :class="[question.LabelStyleClass ? '' : 'baseSelect']"
        ref="baseSelect"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title>
              <div :value="item.Value" :data-uiid="item.DataUiid">
                {{ item.Text }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-slot:append>
          <span>
            <v-icon
              v-if="!$refs.baseSelect?.valid && $refs.baseSelect?.hasMessages"
              color="red"
              size="20"
              :class="[question?.IconStyleClass]"
              >mdi-alert-circle</v-icon
            >
            <v-icon>mdi-menu-down</v-icon>
          </span>
        </template>
      </v-select>
    </div>
    <div v-if="showRentalError()" class="col-12 col-lg-8 pa-0 pr-lg-2 mt-4">
      <div class="bg-red-50 rounded ownership-warning">
        <div class="d-flex">
          <v-icon color="var(--red-500)" class="mr-2 align-self-start"
            >mdi-alert-circle</v-icon
          >
          <span
            ><strong>Sorry!</strong> We're unable to offer Buildings Insurance
            for this type of property. Please change your chosen cover type to
            Contents only.</span
          >
          <BaseButton
            text="Edit cover"
            flat
            link
            icon="mdi-pencil"
            depressed
            color="black--text"
            ripple
            small
            iconSize="14"
            class="d-none d-md-flex align-self-center px-1 font-weight-600 black2-color"
            @click="$router.push('/')"
          />
        </div>
        <div class="d-flex justify-center">
          <BaseButton
            text="Edit cover"
            flat
            link
            icon="mdi-pencil"
            depressed
            iconSize="14"
            color="black--text"
            ripple
            small
            class="d-flex d-md-none align-self-center px-0 font-weight-600 mt-2 mt-md-0 black2-color"
            @click="$router.push('/')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  QUESTIONS_MODULE,
  APPLICATION_MODULE,
} from "@/store/types/module-types";
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "SelectToggleHiddenQuestion",
  components: {
    HomeBaseLabel,
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  watch: {
    question: {
      handler(val) {
        this.$emit("change", val);
      },
      deep: true,
    },
    "question.Value": {
      immediate: true,
      handler() {
        this.getValue(this.question);
      },
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, {
      questionsModule: "setQuestionVisibility",
    }),
    ...mapActions(APPLICATION_MODULE, {
      applicationModule: "setQuestionVisibility",
    }),
    getValue(question, resetSource = false) {
      this.questionsModule(question);
      this.applicationModule(question);
      if (resetSource) this.question.Source = "User";
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["showRentalError"]),
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-text-field.v-text-field--enclosed .v-text-field__details) {
  padding-left: 0;
}
:deep(.v-text-field input::placeholder) {
  color: black !important;
}
.ownership-status {
  margin-bottom: 9px !important;
}
.ownership-warning {
  border-radius: 10px !important;
  padding: 20px !important;
  color: #272727 !important;
  margin-bottom: 36px;
  margin-top: -22px;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.icon-mt {
  margin-top: 1px !important;
}
</style>
